import { focusOn as r } from "./commands.js";
import { focusSolver as s } from "./focusSolver.js";
var o = 0, t = !1, a = function(f, u, e) {
  e === void 0 && (e = {});
  var c = s(f, u);
  if (!t && c) {
    if (o > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting"), t = !0, setTimeout(function() {
        t = !1;
      }, 1);
      return;
    }
    o++, r(c.node, e.focusOptions), o--;
  }
};
export {
  a as moveFocusInside
};
